import React from 'react'
import PropTypes from 'prop-types'
import { useNavigate } from 'react-router-dom'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material'
import { toast } from 'react-toastify'
import styles from './UnlockUserModal.module.scss'
import { unlockUser } from '../../../../services/user'

const UnlockUserModal = ({ showModal, handleClose, user, onUnlockSuccess }) => {
  const navigate = useNavigate()
  const editStyle = {
    backgroundColor: '#eb1700',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '120px',
    span: {
      margin: '0 !important',
    },
    '&:hover': {
      backgroundColor: '#CC1400',
    },
    '&:disabled': {
      backgroundColor: '#665A47',
    },
    '&:focus': {
      backgroundColor: '#CC1400',
    },
  }
  const cancelStyle = {
    backgroundColor: '#FFFFFF',
    '&:hover': {
      backgroundColor: '#FFFFFF',
    },
    '&:focus': {
      backgroundColor: '#FFFFFF',
    },
  }

  const handleAfterUnlockUserSuccess = () => {
    onUnlockSuccess()
    handleClose()
    navigate(`/view-user/${user?.id}`)
  }
  const makeUnlockUserDTO = () => {
    user.status = 'ACTIVE'
    user.active = true
  }
  const handleUnlockFailure = (error) => {
    toast.error(error?.message)
  }
  const handleUnlockUser = () => {
    const userDTO = makeUnlockUserDTO()
    unlockUser(userDTO, user.id)
    .then(handleAfterUnlockUserSuccess)
    .catch(handleUnlockFailure)
  }

  return (
    <Dialog
      open={showModal}
      onClick={(e) => e.stopPropagation()}
      PaperProps={{
        className: styles.dialogContainer,
      }}
    >
      <DialogTitle className={styles.dialogTitle}>
        Are you sure you want to unlock this user?
      </DialogTitle>
      <DialogContent className={styles.dialogContent}>
        <DialogContentText
          className={styles.dialogText}
        >
          This action cannot be undone.
        </DialogContentText>
      </DialogContent>
      <DialogActions className={styles.dialogActionButtons}>
        <Button
          onClick={handleClose}
          className="secondary-btn"
          variant="contained"
          disableElevation
          sx={{
            ...cancelStyle,
            marginTop: '20px',
            color: '#000',
          }}
        >
          Cancel
        </Button>
        <Button
          className="primary-btn"
          onClick={handleUnlockUser}
          variant="contained"
          disableElevation
          sx={{ ...editStyle, marginTop: '20px' }}
        >
          Yes, unlock this user
        </Button>
      </DialogActions>
    </Dialog>
  )
}
UnlockUserModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  onUnlockSuccess: PropTypes.func.isRequired,
}

export default UnlockUserModal;
